module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cm-service-popups'), _vm._v(" "), _c('cm-service-switcher-popup', {
    attrs: {
      "closeButton": true
    }
  }), _vm._v(" "), _c('cm-switch-profile', {
    attrs: {
      "closeButton": true
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e1a9737", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e1a9737","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/Popups.vue
// module id = 1637
// module chunks = 2